import { MINCOL } from "../../../constants/const"
import DropdownFilter from "../SD_einsehen/DropdownFilter"

export const linieHeader = [
    {accessor: 'id',
    Header: 'ID'},
    {accessor: 'linie',
    Header: 'Bezeichnung der Linie'},
    {accessor: 'id_vm',
    Header: 'ID Verkehrsmittel'},
    {accessor: 'korr_vm',
    Header: 'Verkehrsmittel'},    
]
export const linieHeaderExtra = [
    {accessor: 'id',
    Header: 'ID'},
    {accessor: 'linie',
    Header: 'Bezeichnung der Linie',
    Filter: DropdownFilter,
    width: '12em'},
    {accessor: 'id_vm',
    Header: 'ID Verkehrsmittel'},
    {accessor: 'vm',
    Header: 'Verkehrsmittel',
    Filter: DropdownFilter,
    width: MINCOL},    
]

export const linieInputs = ['linie']
export const linieDropdowns = ['korr_vm']